import { z } from "zod";

import { ALL_PERMISSIONS } from "~/common/constants";

export const permissionSchema = z.object({
  code: z.enum(ALL_PERMISSIONS),
  description: z.string(),
  id: z.uuid(),
});

export const userPermissionSchema = z.object({
  deleted_at: z.string().nullable(),
  id: z.uuid(),
  permission_id: z.uuid(),
  permission: permissionSchema,
  user_id: z.uuid(),
});
